import { Component, Input } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { DocumentPreview, TransportDocumentType } from 'src/tmc-yard/components/transport-details-legacy/model/document-preview';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-transport-document-item',
  templateUrl: './transport-document-item.component.html',
  styleUrls: ['./transport-document-item.component.scss']
})
export class TransportDocumentItemComponent {

  previewType = 'UNKNOWN';

  previewMimeTypes = ['image/png', 'image/jpeg'];

  preview: DocumentPreview;
  @Input('preview') set setPreview(preview: DocumentPreview) {
    this.preview = preview;

    if (this.previewMimeTypes.indexOf(this.preview.mimeType) !== -1) {
      this.previewType = 'PICTURE';
    } else if (this.preview.mimeType === 'application/pdf') {
      this.previewType = 'PDF';
    }
  }

  documentType = TransportDocumentType;

  environment = environment;

  constructor(
    public translationService: TranslationService
  ) {
  }

}
